import { render } from "./allToTr.vue?vue&type=template&id=4c7d6449&scoped=true"
import script from "./allToTr.vue?vue&type=script&lang=js"
export * from "./allToTr.vue?vue&type=script&lang=js"

import "./allToTr.vue?vue&type=style&index=0&id=4c7d6449&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7d6449"]])

export default __exports__